import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Background from '../../../components/Background/Background';
import CompressedResult from '../CompressedResult/CompressedResult';
import classes from './Output.styles.less';
export default function Output({ results }) {
    const files = Object.keys(results).sort((a, b) => results[b].queue - results[a].queue);
    if (files.length === 0) {
        return null;
    }
    const items = files.map((fileKey) => {
        if (!results[fileKey].content) {
            return null;
        }
        if (results[fileKey].error) {
            return (_jsx(Background, { className: classes.wrapper, children: "Failed to parse SVG file" }, fileKey));
        }
        return _jsx(CompressedResult, { content: results[fileKey].content, fileKey: fileKey }, fileKey);
    });
    return items;
}
